export function GreenStatusIcon({ small }: { small?: boolean }) {
  const width = small ? '16' : '20'
  const height = small ? '17' : '21'
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 20 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      data-testid='green-status-icon'
    >
      <rect y='0.5' width='20' height='20' rx='10' fill='var(--green)' />
      <path
        d='M15.1933 8.13836L8.82969 14.502C8.77427 14.5576 8.70841 14.6017 8.63589 14.6319C8.56337 14.662 8.48563 14.6775 8.40711 14.6775C8.32859 14.6775 8.25084 14.662 8.17832 14.6319C8.10581 14.6017 8.03995 14.5576 7.98452 14.502L5.20043 11.7179C5.14494 11.6624 5.10092 11.5965 5.07088 11.524C5.04085 11.4515 5.02539 11.3738 5.02539 11.2953C5.02539 11.2168 5.04085 11.1391 5.07088 11.0666C5.10092 10.9941 5.14494 10.9282 5.20043 10.8727C5.25593 10.8172 5.32181 10.7732 5.39431 10.7432C5.46682 10.7132 5.54454 10.6977 5.62302 10.6977C5.7015 10.6977 5.77921 10.7132 5.85172 10.7432C5.92423 10.7732 5.99011 10.8172 6.0456 10.8727L8.4076 13.2347L14.3492 7.29418C14.4612 7.1821 14.6132 7.11914 14.7717 7.11914C14.9302 7.11914 15.0822 7.1821 15.1943 7.29418C15.3064 7.40626 15.3694 7.55827 15.3694 7.71677C15.3694 7.87527 15.3064 8.02728 15.1943 8.13935L15.1933 8.13836Z'
        fill='#010101'
      />
    </svg>
  )
}

export default function StatusIcon() {
  return (
    <svg width='20' height='21' viewBox='0 0 20 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect y='0.5' width='20' height='20' rx='10' fill='none' fillOpacity='0.2' />
      <path
        d='M15.1933 8.13787L8.82969 14.5015C8.77427 14.5571 8.70841 14.6013 8.63589 14.6314C8.56337 14.6615 8.48563 14.677 8.40711 14.677C8.32859 14.677 8.25084 14.6615 8.17832 14.6314C8.10581 14.6013 8.03995 14.5571 7.98452 14.5015L5.20043 11.7174C5.14494 11.6619 5.10092 11.596 5.07088 11.5235C5.04085 11.451 5.02539 11.3733 5.02539 11.2948C5.02539 11.2163 5.04085 11.1386 5.07088 11.0661C5.10092 10.9936 5.14494 10.9277 5.20043 10.8722C5.25593 10.8168 5.32181 10.7727 5.39431 10.7427C5.46682 10.7127 5.54454 10.6972 5.62302 10.6972C5.7015 10.6972 5.77921 10.7127 5.85172 10.7427C5.92423 10.7727 5.99011 10.8168 6.0456 10.8722L8.4076 13.2342L14.3492 7.29369C14.4612 7.18162 14.6132 7.11865 14.7717 7.11865C14.9302 7.11865 15.0822 7.18162 15.1943 7.29369C15.3064 7.40577 15.3694 7.55778 15.3694 7.71628C15.3694 7.87478 15.3064 8.02679 15.1943 8.13886L15.1933 8.13787Z'
        fill='currentColor'
      />
    </svg>
  )
}
